// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rename-collection[data-v-2000ea60]{position:absolute;top:8px;left:25px;width:280px;background-color:#fff;z-index:1}", ""]);
// Exports
module.exports = exports;
